export default "__VITE_ASSET__I3kwLxvI__"